var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletPortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 6,
    width: 141,
    height: 204,
    rx: 21,
    fill: "white",
    fillOpacity: 0.08,
    stroke: "#F8FAFC",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 183.801H134",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletPortrait);
export default __webpack_public_path__ + "static/media/tablet-portrait.e8f5af7ac7308243e944a0b9447d4005.svg";
export { ForwardRef as ReactComponent };